var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form__wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png")}}),_c('h1',[_vm._v("proton.ai")]),_c('div',[_c('h3',[_vm._v("You've successfully logged out of Proton.")]),_c('p',[_vm._v("To log back in, please visit your company-specific Proton URL (yourcompany.proton.ai)")])])])
}]

export { render, staticRenderFns }